export type AppLanguage = 'en' | 'ms';

export interface LanguageOption {
  code: AppLanguage;
  label: string;
  name: string;
  locale: string;
}

export const SUPPORTED_LANGUAGES: readonly LanguageOption[] = [
  { code: 'en', label: 'EN', name: 'English', locale: 'en-GB' },
  { code: 'ms', label: 'MS', name: 'Bahasa Melayu', locale: 'ms-MY' },
] as const;

export const DEFAULT_LANGUAGE: AppLanguage = 'en';

export const LANGUAGE_STORAGE_KEY = 'app_language';
